import styled from 'styled-components';
import Grid from 'styled-components-grid';
import breakpoint from 'styled-components-breakpoint';
import {
  py, px, p, pt, pb, pr, ml, mb, mt, mx
} from 'styled-components-spacing';

import { sectionSpacing } from '@components/Wrappers/styles';
import { SvgChevronRight, SvgChevronLeft } from '@images/svg';

import { buttonLight } from '@styles/buttons';
import {
  INPUT_CONTAINER_CLASSNAME,
  INPUT_CLASSNAME,
  DROPDOWN_CLASSNAME,
  SUGGESTION_CLASSNAME,
  SUGGESTION_ACTIVE_CLASSNAME
} from '@components/InputPlacesAutocomplete';
import theme from '@theme';
import ProgressBar from '@ramonak/react-progress-bar';

const { borderRadius, shadows, colors } = theme;

const colorInput = 'rgba(100, 175, 213, 0.1)';

export const StyledButtonNext = styled.button`
  ${buttonLight}
  justify-content: center;
  width: 100%;

  ${breakpoint('mobile', 'desktop')`
    padding: 0.3rem;
    margin-top: 10px;
    margin-right: 0.2rem;
    height: 50px;
  `}

  ${breakpoint('desktop')`
    ${mx(0)}
    width: auto;
  `}
`;

export const StyledButtonBack = styled.button`
  cursor: pointer;
  border: none;
  padding: 0px;
  ${mx(3.5)}
  background: none;
  justify-content: center;
  width: auto;
  position: absolute;
  align-self: center;

  ${breakpoint('desktop')`
    ${mx(0)}
  `}

  ${breakpoint('mobile', 'desktop')`
    display: inline-block;
    margin-left: 0px;
    height: 50px;
  `}
`;

export const StyledWrapper = styled.div`
  min-height: 1rem;
`;

export const StyledFormHeadline = styled.h1`
  display: flex;
  width: 100%;
  justify-content: center;
  flex-direction: column;
  align-content: center;
  font-weight: 700;
  font-size: ${props => (props.formName ? '18px' : '1.5rem')};
  line-height: 2.5rem;
  cursor: ${props => (props.formName ? 'default' : 'pointer')};
  display: ${({ signUp }) => (signUp ? 'none' : '')};
   ${breakpoint('mobile', 'tablet')`
    font-size: ${props => (props.formName ? '18px' : '24px')};
    font-weight: 700;
    line-height: 29px;   
  `} ${breakpoint('mobile', 'desktop')`
    padding-top: 10px;
    padding-bottom: 10px;
  `};
`;

export const StyledProgressBar = styled(ProgressBar)`
  > div {
    background-color: ${colors.lightGray} !important;
    > div {
      background: none !important;
      height: 100% !important;
      background-color: ${colors.newThemeDarkBlue} !important;
    }
  }

  ${props => (props.formName ? mb(0) : mb(4))}
`;

export const StyledHeader = styled.div`
  ${props => (props.formName ? pt(2) : pt(4))}
  ${props => (props.formName ? pb(2) : pb(4))}
  ${props => props.formName && 'border-radius: 10px;'}
  display: flex;
  justify-content: space-between;
  align-content: flex-start;
  color: ${theme.colors.white};
  background-image:${props => (props.domain
    ? `
    linear-gradient(
    118.6deg,
    #5BA0A0 2%,
    #448989 30%,
    #276363 66%,
    #144D4D 100%
  )
    ` : `
    linear-gradient(
    118.6deg,
    #63aecf 0%,
    #629ece 30.63%,
    #458fd3 63.31%,
    #3a78b1 98.02%
  )
   `)}!important;
  font-size: 1rem;
  line-height: 1.5rem;
  text-align: center;
  font-weight: 500;

  ${breakpoint('desktop')`
    font-size: 1.5rem;
    line-height: 2.5rem;
  `}
`;

export const StyledMiniFlowWrapper = styled.div`
  ${({ treatmentPage }) => (treatmentPage ? mt(0) : pt(4))}
  ${({ treatmentPage }) =>
    treatmentPage && 'border-radius: 10px;'}
  
  .styles__StyledCoverMaxWidth-sc-5r7r1a-0 {
    margin-bottom: 0px;
  }

  ${px(0.5)}
  display: block;
  ${sectionSpacing}
  .carousel {
    .control-dots {
      display: none;
      top: 0;
      pointer-events: none;
      .dot {
        background: ${colors.white};
      }
    }
    .slide {
      transition: none;
      height: 0;
      background: none;
      text-align: left;
    }
    .slide.selected {
      display: flex;
      height: auto;
    }
  }
  background-clip: content-box, padding-box;
  background-image:${props => (props.domain
    ? `
    linear-gradient(
    118.6deg,
    #5BA0A0 2%,
    #448989 30%,
    #276363 66%,
    #144D4D 100%
  )` : `linear-gradient(
    118.6deg,
    #63aecf 0%,
    #629ece 30.63%,
    #458fd3 63.31%,
    #3a78b1 98.02%
  ) `)}!important;

  ${breakpoint('mobile')`
    ${pt(0)}
    scroll-margin-top:58px;
  `}

  ${breakpoint('desktop')`
  scroll-margin-top:81px;
    margin-bottom: 0px;
    .slider-wrapper {
      width: 100%;
    }
    .carousel {
      .control-dots {
        width: 100%;
        margin-left: 1rem;
      }
    }
    ${px(0)}
    ${pb(0)}
  `}
  margin-bottom: 0px;
`;

export const StyledHeadlineText = styled.h3`
  color: ${colors.white};
  font-size: 60px;
  line-height: 1.1;
  display: block;
  ${mb(3.5)}
  ${theme.typography.Raleway}

  ${breakpoint('desktop')`
    font-size: 80px;
  `}
`;

export const StyledSubline = styled.span`
  color: ${colors.white};
  font-size: 2rem;
  line-height: 1.75;
  display: block;
  ${mb(4.5)}

  ${breakpoint('desktop')`
    ${mb(0)}
  `}
`;

export const StyledHeadlineTextAlternate = styled.span`
  font-style: italic;
`;

export const StyledCard = styled.div`
  ${({ noPadding }) => (noPadding ? '' : py(3.5))}
  ${borderRadius.default}
  ${shadows.larger}
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 520px;
  height: auto; // IE needs any height

  ${breakpoint('desktop')`
    ${({ noPadding }) => (noPadding ? '' : p(4.5))}
    ${px(0)}
    ${pt(0)}
    ${borderRadius.large}
  `}
`;

export const StyledContentCover = styled.div`
  ${({ noPadding }) => (noPadding ? '' : px(0))}
  flex: 1 0 auto;
  display: flex;
  justify-content: center;
  flex-direction: column;

  ${breakpoint('desktop')`
    display: block;
    ${px(0)}
  `}
`;

export const StyledControlsWrapper = styled.div`
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-end;
  padding: 10px;
`;

export const StyledIcon = styled(SvgChevronRight)`
  ${ml(3)}
  height: 12px;
  width: 12px;

  g {
    fill: ${colors.turquoise};
  }
  flex: 0 0 auto;
`;

export const StyledBackButton = styled(SvgChevronLeft)`
  ${({ slide }) => (slide === 0 ? 'display: none;' : '')}
  ${({ success }) => (success ? 'display: none;' : '')}

  ${ml(3)}
  height: 12px;
  width: 12px;
  flex: 0 0 auto;
`;

export const StyledItemClaim = styled(Grid.Unit)`
  ${pr(3)}
  flex-direction: column;
`;

export const StyledContentHeadline = styled.h4`
  ${mb(4)}
  ${px(3)}
  font-size: 38px;
  line-height: 43px;
  text-align: center;
  font-weight: 600;

  ${theme.typography.Raleway}
  color: ${theme.colors.white};

  ${breakpoint('mobile', 'tablet')`
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
  `}
  
  ${breakpoint('desktop')`
    ${mt(2.5)}
    ${mb(5)}
    font-size: 2rem;
  `}
`;

export const StyledContentTreatmentHeadline = styled.h4`
  ${mb(5.5)}
  ${px(3)}
  font-size: 1.5rem;
  line-height: 2.5rem;
  text-align: center;
  font-weight: 500;

  ${theme.typography.Raleway}
  color: ${theme.colors.white};

  ${breakpoint('desktop')`
    ${mt(2.5)}
    ${mb(5)}
    font-size: 2rem;
  `}
`;

export const StyledSelect = styled.select`
  ${p(3)}
  ${borderRadius.small}
  background: none;
  border: 0;
  appearance: none;
  background-color: ${colorInput};
  width: 100%;

  color: ${({ value }) => (value ? 'black' : 'grey')};
  font-size: 1rem;

  &::-ms-expand {
    display: none;
  }
`;

export const StyledInputContainer = styled.div`
  position: relative;

  & > * > .${INPUT_CONTAINER_CLASSNAME} > .${INPUT_CLASSNAME} {
    ${p(3)}
    ${borderRadius.small}
    appearance: none;
    background: none;
    border: 0;
    background-color: ${colorInput};
    font-size: 1rem;
    width: 100%;

    &::-ms-clear {
      display: none;
    }
  };

  & > * > .${DROPDOWN_CLASSNAME} {
    position: absolute;
    top: 3rem;
    left: 0;
    z-index: 10;
    width: 100%;

    & .${SUGGESTION_ACTIVE_CLASSNAME} {
      ${py(3)}
      ${px(2)}
      background-color: ${colors.greyBlue10};
      cursor: pointer;
    };

    & .${SUGGESTION_CLASSNAME} {
      ${py(3)}
      ${px(2)}
      background-color: #fafafa;
      cursor: pointer;
    }
  };
`;

export const StyledContinueButton = styled.div`
color:#3EC6E3;
`;
